import axios from "axios"
import type {AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig, AxiosResponse} from 'axios'

class Server{
    private instance: AxiosInstance

    constructor() {
        this.instance = axios.create({
            baseURL: 'https://zjippc-api.myfriends973.com/',
            timeout: 20000
        })

        this.instance.interceptors.request.use(
            this.requestInterceptionSuccess,
            this.requestInterceptionError
        )

        this.instance.interceptors.response.use(
            this.responseInterceptionSuccess,
            this.responseInterceptionError
        )
    }

    // eslint-disable-next-line
    request<T = any>(config: AxiosRequestConfig): Promise<T> {
        return this.instance(config)
    }

    private requestInterceptionSuccess(config: InternalAxiosRequestConfig) {
        return config
    }

    // eslint-disable-next-line
    private requestInterceptionError(error: any) {
        return Promise.reject(error)
    }

    private responseInterceptionSuccess(response: AxiosResponse) {
        if (response.data?.code === 0) {
            return response.data
        }
        return Promise.reject(response)
    }

    // eslint-disable-next-line
    private responseInterceptionError(error: any) {
        // 超出 2xx 范围的状态码都会触发该函数。
        // 对响应错误做点什么
        return Promise.reject(error);
    }
}

export default new Server()